import { memo } from "react";

import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props interface for AIPlayerSummaryLoadingStateView component
 */
interface AIPlayerSummaryLoadingStateViewProps {
  isDark: boolean;
  isSmallScreen: boolean;
  statusMessage: string;
}

/**
 * AIPlayerSummaryLoadingStateView component - pure UI for loading state
 *
 * Displays an animated status message during AI summary generation.
 * Uses pulse animation to indicate active processing.
 * @param props - Component props
 * @param props.isDark - Whether dark theme is active
 * @param props.isSmallScreen - Whether the screen is small (mobile)
 * @param props.statusMessage - Current status message to display
 */
const AIPlayerSummaryLoadingStateView = ({
  isDark,
  isSmallScreen,
  statusMessage,
}: AIPlayerSummaryLoadingStateViewProps) => (
  <Stack
    className={`items-center justify-center gap-3 ${isSmallScreen ? "py-4" : "py-6"}`}
  >
    <Text
      variant="body-strong"
      className={`animate-pulse text-center ${isDark ? "text-surface-strong" : "text-content-neutral-strong"}`}
    >
      {statusMessage}
    </Text>
  </Stack>
);

AIPlayerSummaryLoadingStateView.displayName = "AIPlayerSummaryLoadingStateView";

export default memo(AIPlayerSummaryLoadingStateView);
